import { PapPackingPictureType } from '@ydistri/api-sdk';
import { useGetPackingPictureFileQuery } from '../../CalculationDetail/Evaluation/apiCalculationEvaluations';
import React from 'react';
import { Alert, Image } from 'antd';
import { Column, Title } from '@ydistri/ds';
import { styled } from 'styled-components';
import LoadingIndicator from '../../../components/global/LoadingIndicator/LoadingIndicator';

const ImageContainer = styled.div`
  width: 100%;
`;

interface BoxPackingSinglePictureProps {
  calculationId: number;
  sourceStoreId: number;
  targetStoreId: number;
  boxNumber: number;
  imageIndex: number;
  packingPictureType: PapPackingPictureType;
}

const pictureTitles: Record<PapPackingPictureType, string> = {
  [PapPackingPictureType.Contents]: 'Contents',
  [PapPackingPictureType.ContentsWithPackagingMaterial]: 'Contents with packaging material',
  [PapPackingPictureType.BoxWithLabelAndSeal]: 'Box with label and seal',
};

// to keep images in correct order for preview group we first assign a transparent picture while loading
const TRANSPARENT_PX = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

const BoxPackingSinglePicture: React.FC<BoxPackingSinglePictureProps> = ({
  boxNumber,
  sourceStoreId,
  targetStoreId,
  packingPictureType,
  calculationId,
  imageIndex,
}) => {
  const { data, isFetching, isError } = useGetPackingPictureFileQuery({
    calculationId,
    sourceStoreId,
    targetStoreId,
    boxNumber,
    packingPictureType,
  });

  return (
    <Column
      $flexGrow="1"
      $flexShrink="1"
      $flexBasis="0"
      $minWidth="0"
      key={boxNumber * 10 + imageIndex}
    >
      <Title>{pictureTitles[packingPictureType]}</Title>
      <ImageContainer>
        {isFetching && <LoadingIndicator text="Loading image..." />}
        {isError && (
          <Alert message="There was a problem downloading the image" type="warning" showIcon />
        )}
        <Image
          src={!isFetching && data ? data.url : TRANSPARENT_PX}
          alt={`Box Packing for box ${boxNumber} - type ${packingPictureType}`}
          decoding="async"
        />
      </ImageContainer>
    </Column>
  );
};

export default BoxPackingSinglePicture;
